module.exports = __webpack_public_path__ + "img/double-sided.058a8472.svg";